import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BaseApiService } from './base-api.service';
import { QuestionnaireRedirect } from '../models/questionnaire-redirect';
import { Questionnaire } from '../models/questionnaire';
import { OnlineQuestionnaire } from '../models/online-questionnaire';

@Injectable({
  providedIn: 'root'
})
export class QuestionnairePortalApiService extends BaseApiService<any> {

   public constructor(httpClient: HttpClient) {
      super(httpClient, `${environment.legacyApiUrl}`);
    }
  
    public GetDocPortalAuth(id: string){
      return this.httpClient.post<QuestionnaireRedirect>(`${this.baseApiUrl}/AuthRedirect/Questionnaire/${id}`, null);
    }

    public GetQuestionnaire(id: string) {
      return this.httpClient.get<Questionnaire>(`${environment.apiUrl}/Questionnaires/${id}`);
    }

    public GetOnlineQuestionnaire(id: string) {
      return this.httpClient.get<OnlineQuestionnaire>(`${environment.apiUrl}/Questionnaires/OnlineQuestionnaire/${id}`);
    }

  }
